import { prettyPrintEnumValue } from "encamp-shared/src/utils/prettyPrintEnumValue";

/**
 * Pretty-print WasteStreamRegistrationStatus. Passes `ignoreStateAbbreviations`
 * so "IN_PROGRESS" renders as "In Progress" rather than "IN Progress" — the
 * generic helper would otherwise treat "IN" as Indiana's state code.
 */
export const prettyPrintWasteStreamRegistrationStatus = (
  status: string | null | undefined
): string => {
  if (!status) return "";
  return prettyPrintEnumValue(status, undefined, true) ?? "";
};
